const localDomain = "http://127.0.0.1:8000"
const hostDomain = 'https://binazirchart.ir'

function getUrl() {
    let REACT_APP_CTCROSS,
        REACT_APP_COMMENT_CREATE,
        REACT_APP_COMMENT_UPDATE,
        REACT_APP_COMMENT,
        REACT_APP_MARKET,
        REACT_APP_MARKET_USERS,
        REACT_APP_MARKET_SYMBOL_LIST,
        REACT_APP_MARKET_SYMBOL_LIST_PAGE,
        REACT_APP_MARKET_SYMBOL_REALTIME,
        REACT_APP_MARKET_SYMBOL_REALTIME_PAGE,
        REACT_APP_MARKET_REALTIME_SYMBOLS,
        REACT_APP_MARKET_REALTIME_SYMBOLS_PAGE,
        REACT_APP_CSRF_TOKEN,
        REACT_APP_LOGIN,
        REACT_APP_JUSTIFY,
        REACT_FIRST_RECORDS,
        REACT_APP_STRATEGY,
        REACT_APP_STRATEGY_CALCULATOR,
        REACT_APP_FILTERS,
        REACT_APP_BLACLSCHOLES_ENDPOINT

    if (window.location.href.includes("http://127.0.0.1:3000") || window.location.href.includes("http://127.0.0.1:8000")) {
        REACT_APP_CTCROSS = `${localDomain}${process.env.REACT_APP_CTCROSS}`
        REACT_APP_COMMENT_CREATE = `${localDomain}${process.env.REACT_APP_COMMENT_CREATE}`
        REACT_APP_COMMENT_UPDATE = `${hostDomain}${process.env.REACT_APP_COMMENT_UPDATE}`
        REACT_APP_COMMENT = `${hostDomain}${process.env.REACT_APP_COMMENT}`
        REACT_APP_MARKET = `${localDomain}${process.env.REACT_APP_MARKET}`
        REACT_APP_MARKET_USERS = `${localDomain}${process.env.REACT_APP_MARKET_USERS}`
        REACT_APP_MARKET_SYMBOL_LIST = `${localDomain}${process.env.REACT_APP_MARKET_SYMBOL_LIST}`
        REACT_APP_MARKET_SYMBOL_LIST_PAGE = `${localDomain}${process.env.REACT_APP_MARKET_SYMBOL_LIST_PAGE}`
        REACT_APP_MARKET_SYMBOL_REALTIME = `${localDomain}${process.env.REACT_APP_MARKET_SYMBOL_REALTIME}`
        REACT_APP_MARKET_SYMBOL_REALTIME_PAGE = `${localDomain}${process.env.REACT_APP_MARKET_SYMBOL_REALTIME_PAGE}`
        REACT_APP_MARKET_REALTIME_SYMBOLS = `${localDomain}${process.env.REACT_APP_MARKET_REALTIME_SYMBOLS}`
        REACT_APP_MARKET_REALTIME_SYMBOLS_PAGE = `${localDomain}${process.env.REACT_APP_MARKET_REALTIME_SYMBOLS_PAGE}`
        REACT_APP_CSRF_TOKEN = `${localDomain}${process.env.REACT_APP_CSRF_TOKEN}`
        REACT_APP_LOGIN = `${localDomain}${process.env.REACT_APP_LOGIN}`
        REACT_APP_JUSTIFY = `${localDomain}${process.env.REACT_APP_JUSTIFY}`
        REACT_FIRST_RECORDS = `${localDomain}${process.env.REACT_APP_FIRST_RECORDS_URL}`
        REACT_APP_STRATEGY = `${localDomain}${process.env.REACT_APP_STRATEGY}`
        REACT_APP_FILTERS = `${localDomain}${process.env.REACT_APP_FILTERS}`
        REACT_APP_STRATEGY_CALCULATOR = `${localDomain}${process.env.REACT_APP_STRATEGY_CALCULATOR}`
        REACT_APP_BLACLSCHOLES_ENDPOINT = `${localDomain}${process.env.REACT_APP_BLACLSCHOLES_ENDPOINT}`

    } else {
        // REACT_APP_CTCROSS = `${hostDomain}${process.env.REACT_APP_CTCROSS}`
        REACT_APP_CTCROSS = `https://api.binazirchart.ir${process.env.REACT_APP_CTCROSS}`
        REACT_APP_COMMENT_CREATE = `${hostDomain}${process.env.REACT_APP_COMMENT_CREATE}`
        REACT_APP_COMMENT_UPDATE = `${hostDomain}${process.env.REACT_APP_COMMENT_UPDATE}`
        REACT_APP_COMMENT = `${hostDomain}${process.env.REACT_APP_COMMENT}`
        REACT_APP_MARKET = `${hostDomain}${process.env.REACT_APP_MARKET}`
        REACT_APP_MARKET_USERS = `${hostDomain}${process.env.REACT_APP_MARKET_USERS}`
        REACT_APP_MARKET_SYMBOL_LIST = `${hostDomain}${process.env.REACT_APP_MARKET_SYMBOL_LIST}`
        REACT_APP_MARKET_SYMBOL_LIST_PAGE = `${hostDomain}${process.env.REACT_APP_MARKET_SYMBOL_LIST_PAGE}`
        REACT_APP_MARKET_SYMBOL_REALTIME = `${hostDomain}${process.env.REACT_APP_MARKET_SYMBOL_REALTIME}`
        REACT_APP_MARKET_SYMBOL_REALTIME_PAGE = `${hostDomain}${process.env.REACT_APP_MARKET_SYMBOL_REALTIME_PAGE}`
        REACT_APP_MARKET_REALTIME_SYMBOLS = `${hostDomain}${process.env.REACT_APP_MARKET_REALTIME_SYMBOLS}`
        REACT_APP_MARKET_REALTIME_SYMBOLS_PAGE = `${hostDomain}${process.env.REACT_APP_MARKET_REALTIME_SYMBOLS_PAGE}`
        REACT_APP_CSRF_TOKEN = `${hostDomain}${process.env.REACT_APP_CSRF_TOKEN}`
        REACT_APP_LOGIN = `${hostDomain}${process.env.REACT_APP_LOGIN}`
        REACT_APP_JUSTIFY = `${hostDomain}${process.env.REACT_APP_JUSTIFY}`
        REACT_FIRST_RECORDS = `${hostDomain}${process.env.REACT_APP_FIRST_RECORDS_URL}`
        REACT_APP_STRATEGY = `${hostDomain}${process.env.REACT_APP_STRATEGY}`
        REACT_APP_FILTERS = `${hostDomain}${process.env.REACT_APP_FILTERS}`
        REACT_APP_STRATEGY_CALCULATOR = `${hostDomain}${process.env.REACT_APP_STRATEGY_CALCULATOR}`
        REACT_APP_BLACLSCHOLES_ENDPOINT = `${hostDomain}${process.env.REACT_APP_BLACLSCHOLES_ENDPOINT}`
    }

    return (
        {
            REACT_APP_CTCROSS,
            REACT_APP_COMMENT_CREATE,
            REACT_APP_COMMENT_UPDATE,
            REACT_APP_COMMENT,
            REACT_APP_MARKET,
            REACT_APP_MARKET_USERS,
            REACT_APP_MARKET_SYMBOL_LIST,
            REACT_APP_MARKET_SYMBOL_LIST_PAGE,
            REACT_APP_MARKET_SYMBOL_REALTIME,
            REACT_APP_MARKET_SYMBOL_REALTIME_PAGE,
            REACT_APP_MARKET_REALTIME_SYMBOLS,
            REACT_APP_MARKET_REALTIME_SYMBOLS_PAGE,
            REACT_APP_CSRF_TOKEN,
            REACT_APP_LOGIN,
            REACT_APP_JUSTIFY,
            REACT_FIRST_RECORDS,
            REACT_APP_STRATEGY,
            REACT_APP_FILTERS,
            REACT_APP_STRATEGY_CALCULATOR,
            REACT_APP_BLACLSCHOLES_ENDPOINT
        }
    )
}


export default getUrl